var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid-storico-invii-report-fornitori',{attrs:{"endpoint":"reportfornitore/storico/0","isDettaglio":false}})}
var staticRenderFns = []

export { render, staticRenderFns }